/*
* Created: 4/5/2010
* Created By: Matt Brown (Adapted to InfoLabel by Matt Roselli)
*/

HEIJS.registerNamespace("HEIJS.InfoLabelControl");

HEIJS.InfoLabelControl.Form = function (label)
{
  this.label = label;
  this.setupEvents();
};

HEIJS.InfoLabelControl.Form.prototype =
{
  //
  //  Fields
  //
  label: null,
  toolTipPopupSelector: "div.info-labelcontrol-tooltip",
  toolTipImageSelector: ".info-labelcontrol-image",

  //
  // Methods
  //
  setupEvents: function()
  {
    this.addInformationForHover();
  },

  toolTipPopup_Hover: function() {
    var self = this;
    $(this.toolTipPopupSelector).not(this.label.siblings(this.toolTipPopupSelector)).hide();
    var toolTip = this.label.siblings(this.toolTipPopupSelector);
    toolTip.fadeIn(500);
    self.positionInfoLabel($(toolTip));
  },

  positionInfoLabel: function($toolTip) {
    $toolTip.position(
    {
      of: $toolTip.siblings('div.info-labelcontrol-image').first(),
      my: 'left bottom',
      at: 'top',
      collision: 'flipfit'
    });
  },

  toolTipPopup_LoseHover: function(e)
  {
    if ($.browser.msie) {
      e.relatedTarget = e.toElement;
      e.currentTarget = e.fromElement;
    }

    var shouldKeepHover =
      this.label.siblings(this.toolTipPopupSelector)[0] == e.relatedTarget;

    if (!shouldKeepHover)
      this.label.siblings(this.toolTipPopupSelector).hide();
  },

  addInformationForHover: function()
  {
    var self = this;

    this.label.siblings(this.toolTipImageSelector).hoverIntent(function() { self.toolTipPopup_Hover($(this)); }, function(e) { self.toolTipPopup_LoseHover(e); });
    this.label.siblings(this.toolTipPopupSelector).hoverIntent(function () { }, function (e) { self.toolTipPopup_LoseHover(e); });
  }
};

$(function () { $(".info-labelcontrol").each(function () { new HEIJS.InfoLabelControl.Form($(this)); }); });